import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { IAdminTemplateResult, superAdminFilters } from 'src/app/feature/admin/models/admin';
import { IAdminPermissions, IAdminPermissionsResult } from 'src/app/feature/admin/models/permission';
import { ISiteConfiguration } from 'src/app/feature/admin/models/site-configuration';

export const GetAdminDetailsApiAction = createAction('[AdminDetails] Get AdminDetails');
export const CancelGetAdminDetailsApiAction = createAction('[AdminDetails] Cancel Get AdminDetails');
export const SuccessGetAdminDetailsApiAction =
  createAction('[AdminDetails] Success AdminDetails', props<{ complianceDetails: IAdminTemplateResult }>());
export const ErrorGetAdminDetailsApiAction = createAction('[AdminDetails] Failure AdminDetails', props<Error>());

export const GetAdminPermissionsApiAction =
  createAction('[AdminPermissions] Get AdminPermissions', props<{ filters: superAdminFilters }>());
export const CancelGetAdminPermissionsApiAction = createAction('[AdminPermissions] Cancel Get AdminPermissions');

export const SuccessGetAdminPermissionsApiAction =
  createAction('[AdminPermissions] Success AdminPermissions', props<{ permissions: IAdminPermissionsResult }>());
export const ErrorGetAdminPermissionsApiAction = createAction('[SuperAdminDetails] Failure AdminDetails', props<Error>());
export const UpdateOneAdminPermissionApiAction =
  createAction('[AdminPermissions] Update one Admin Permission', props<{ permission: Update<IAdminPermissions> }>());
export const DeleteOneAdminPermissionApiAction =
  createAction('[AdminPermissions] Delete one Admin Permission', props<{ permissionId: string }>());
export const RemoveAllAdminPermissionApiAction =
  createAction('[AdminPermissions] Remove All Admin Permission');

export const GetSuperAdminPermissionsApiAction =
  createAction('[SuperAdminPermissions] Get SuperAdminPermissions', props<{ filters: superAdminFilters }>());
export const CancelGetSuperAdminPermissionsApiAction = createAction('[SuperAdminPermissions] Cancel Get SuperAdminPermissions');

export const SuccessGetSuperAdminPermissionsApiAction =
  createAction('[AdminPermissions] Success SuperAdminPermissions', props<{ permissions: IAdminPermissionsResult }>());
export const ErrorGetSuperAdminPermissionsApiAction =
  createAction('[SuperAdminDetails] Failure SuperAdminDetails', props<Error>());


export const GetAdminSiteConfigurationsApiAction = createAction('[AdminSiteConfigurations] Get AdminSiteConfigurations');
export const CancelGetAdminSiteConfigurationsApiAction = createAction('[AdminSiteConfigurations] Cancel Get AdminSiteConfigurations');

export const SuccessGetAdminSiteConfigurationsApiAction =
  createAction('[AdminSiteConfigurations] Success AdminSiteConfigurations', props<{ configurations: ISiteConfiguration[] }>());
export const RemoveAllAdminSiteConfigurationsApiAction =
  createAction('[AdminSiteConfigurations] Remove All AdminSiteConfigurations');
export const ErrorGetAdminSiteConfigurationsApiAction = createAction('[AdminSiteConfigurations] Failure AdminSiteConfigurations', props<Error>());

export const UpdateAdminSiteConfigurationsAction =
  createAction('[AdminSiteConfigurations] Update AdminSiteConfigurations', props<{ configuration: Update<ISiteConfiguration> }>());
export const UpdateOneSuperAdminPermissionApiAction =
  createAction('[SuperAdminPermissions] Update one Super Admin Permission', props<{ permission: Update<IAdminPermissions> }>());
export const DeleteOneSuperAdminPermissionApiAction =
  createAction('[AdminPermissions] Delete one Super Admin Permission', props<{ permissionId: string }>());
export const RemoveAllSuperAdminPermissionApiAction =
  createAction('[AdminPermissions] Remove All Super Admin Permission');
